import type { AuthenticationClient } from '@wetransfer/authentication';
import { AuthenticationAdapter } from '@wetransfer/authentication';

import { ROUTES } from '@app/config/constants';

const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN ?? '',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID ?? '',
  audience: process.env.REACT_APP_AUTH0_AUDIENCE ?? '',
  redirectUri: `${window.location.origin}${ROUTES.CALLBACK}`,
  useRefreshTokens: true,
};

const client = new AuthenticationAdapter({
  authenticationClientOptions: auth0Config,
});

export async function init({
  callback = false,
  onLoginCallback,
}: {
  callback?: boolean;
  onLoginCallback: () => void | Promise<void>;
}) {
  if (callback) {
    await (
      client.getActiveAuthClient() as AuthenticationClient
    ).handleRedirectCallback();
  }

  let isLoggedIn;

  try {
    await client.checkSession();
    isLoggedIn = await client.isAuthenticated();

    if (callback) {
      await onLoginCallback();
    }
  } catch {
    isLoggedIn = false;
  }

  return {
    isLoggedIn,
    getToken: () => client.getTokenSilently(),
    getUser: () =>
      (client.getActiveAuthClient() as AuthenticationClient).getUser(),
    getIdToken: () => client.getIdTokenClaims(),
  };
}

export async function signUp({ search }: { search?: string } = {}) {
  await client.signUp({
    search,
  });
}

export async function login({ search }: { search?: string } = {}) {
  await client.login({
    search,
  });
}

export function logout() {
  void client.logoutSession({
    returnTo: window.location.origin,
  });
}
